<template>
    <section v-if="result" class="main-slider">
        <swiper
            :modules="modules"
            :slides-per-view="1"
            :pagination="{ clickable: true }"
            navigation
        >
            <swiper-slide
                v-for="(item, i) in result.items"
                :key="i"
            >
                <a
                    :href="item.link || item.detailPage"
                    class="main-slider__link"
                >
                    <div v-if="item.html">
                        <DefInsertTildaSlider :result="item.html"/>
                    </div>
                    <DefVideo
                        v-else-if="item.video"
                        :result="item.video"
                    />
                    <DefPicture
                        v-else
                        :result="item.animation || item.pictures"
                    />
                </a>
            </swiper-slide>
        </swiper>
    </section>
</template>

<script>
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import DefInsertTildaSlider from "../def/DefInsertTilda/DefInsertTildaSlider";

export default {
    name: 'MainSlider',
    selector: '.main-slider',
    props: {
        result: {
            // type: Array,
        }
    },
    components: {
        Swiper,
        SwiperSlide,
        DefInsertTildaSlider,
    },
    data() {
        return {
            modules: [Navigation, Pagination],
            // settings: {
            //     itemsToShow: 1,
            //     autoPlay: true,
            //     playSpeed: 7000,
            //     wheelControl: false,
            // }
        }
    },
}
</script>

<style lang="scss" scoped>
.main-slider{
    @include point-md{
        margin-bottom: 104px;
    }
    &__link{
        display: block;
    }
    img{
        width: 100%;
    }
    :deep(.swiper-button-next:after),
    :deep(.swiper-button-prev:after){
        font-size: 16px;
        color: var(--text-colour-primary);
    }
    :deep(.swiper-pagination-bullet){
        background-color: #DFDFDF;
        width: 10px;
        height: 10px;
        margin-left: 0;
        &:not(:last-child){
            margin-right: 22px;
        }
    }
    :deep(.swiper-pagination-bullet-active){
        background-color: var(--border-colour-primary);
    }
}
</style>